import { AxiosInstance } from 'axios';
import baseAxios from '@/helpers/forms/axios';

export interface PickListItemData {
    title: string
    sku: string
    quantity: number
    identifiers?: Record<string, string>
}

export interface PickListData {
    title: string
    description: string
    items: PickListItemData[]
}

export default (axios: AxiosInstance = baseAxios): { generate: (pickLists: PickListData[]) => Promise<string>; } => ({
    generate: async (pickLists: PickListData[]): Promise<string> => {
        const response = await axios.post<{ url: string }>('/api/pick-list', { pick_lists: pickLists });

        return response.data.url;
    },
});
